var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "common" },
    [
      _c("div", { staticClass: "scroll" }, [
        _c("article", { staticClass: "contents" }, [
          _c(
            "div",
            {
              staticClass: "account-info -type4 nomargin-bottom",
              on: { click: _vm.goPrev }
            },
            [
              _c("div", { staticClass: "tit" }, [
                _vm._v(" " + _vm._s(this.acnoInfo.acno) + " "),
                this.acnoInfo.alias != ""
                  ? _c("span", [
                      _vm._v("(" + _vm._s(this.acnoInfo.alias) + ")")
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "desc" }, [
                _c("div", { staticClass: "item account" }, [
                  _vm._v(_vm._s(this.acnoInfo.ovsesCustOcntryName))
                ])
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "breakdown" },
            [
              _c("strong", { staticClass: "total-count" }, [
                _vm._v(
                  " " +
                    _vm._s(/*총 건수*/ _vm.$t("MCOM-0000079")) +
                    " : " +
                    _vm._s(_vm.RBF0409S40Response.totalCnt) +
                    " "
                ),
                _c("i", {
                  staticClass: "icon icon-import",
                  on: { click: _vm.modalOpen }
                })
              ]),
              _c("common-grid", {
                ref: "commonGrid",
                attrs: {
                  list: _vm.RBF0409S40Response.dataGrid,
                  "total-line-cnt": _vm.RBF0409S40Response.totalCnt,
                  "scroll-event": true,
                  tagType: "div",
                  totalCss: ["total-count", "no-border"],
                  showTotalLineCnt: false
                },
                on: { reSearch: _vm.scrollEvent },
                scopedSlots: _vm._u([
                  {
                    key: "list",
                    fn: function(data) {
                      return [
                        _c("ul", { staticClass: "breakdown-list" }, [
                          _c("li", [
                            _c("ul", [
                              _c("li", { staticClass: "list-item" }, [
                                _c("div", { staticClass: "item strong" }, [
                                  _c("div", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          data.row
                                            .brncoElctrFinacTranPtrnDstcd +
                                            "_BO전자금융거래유형"
                                        )
                                      )
                                    )
                                  ]),
                                  data.row.acidntRprtRegiStusDstcd == "1"
                                    ? _c(
                                        "div",
                                        { staticClass: "desc warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                data.row
                                                  .acidntRprtRegiStusDstcd +
                                                  "_사고신고등록상태"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "desc normal" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                data.row
                                                  .acidntRprtRegiStusDstcd +
                                                  "_사고신고등록상태"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                ]),
                                _c("div", { staticClass: "item etc" }, [
                                  _c("div", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("MACD-01-01-10") /*신고일*/)
                                    )
                                  ]),
                                  _c("div", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getGlobalDateFmt(
                                          data.row.acidntRprtYmd
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "item etc" }, [
                                  _c("div", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("MACD-01-06-02") /*거래종류*/
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          data.row
                                            .brncoElctrFinacTranPtrnDstcd +
                                            "_BO전자금융거래유형"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "item etc" }, [
                                  _c("div", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("MACD-01-06-03") /*신고채널*/
                                      )
                                    )
                                  ]),
                                  _c("div", { staticClass: "desc" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          data.row.chnlDstcd + "_채널구분코드"
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ]),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: { opened: _vm.type, modalHeader: true, modalFooter: true },
        on: {
          "update:opened": function($event) {
            _vm.type = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "MACD-01-06-12"
                        ) /*인터넷뱅킹을 비롯하여 모든 전자금융 사고신고 내역까지 조회하실 수 있습니다.*/
                      ) +
                      " "
                  )
                ]),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      /*10년 이내의 내역만 조회하실 수 있습니다*/ _vm.$t(
                        "MACD-01-06-05"
                      )
                    )
                  )
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        /*신고사항의 해제는 영업점에서 본인확인 후에 가능하므로 신분증(기업 고개의 경우 법인 관련 서류)을 지참하시고 영업점에 방문하셔서 서면으로 신청하셔야 합니다.*/ _vm.$t(
                          "MACD-01-03-12"
                        )
                      ) +
                      " "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        _vm.type = !_vm.type
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("MPRS-01-01-07-16") /*확인*/))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }